
export function getActionName(action: eParticaAction) {
	return eParticaAction[action];
}

export interface ParticaEvent {
	action: eParticaAction;
	item: any;
	sourceEvent: MouseEvent;
}

export enum eParticaAction {

	NONE = 9999,

	CONTENT_STREAM_ADD = 10000,
	CONTENT_STREAM_LEVEL_SAVE = 10001,
	CONTENT_STREAM_ISSUE_SAVE = 10002,
	CONTENT_STREAM_ADD_ARTICLE_ISSUE = 10003,
	CONTENT_STREAM_REMOVE_ARTICLE_ISSUE = 10004,
	CONTENT_STREAM_FINALIZE_ISSUE = 10005,
	CONTENT_STREAM_SAVE_CONFIRM = 10006,
	CONTENT_STREAM_SAVE_CANCEL = 10007,
	CONTENT_STREAM_SAVE = 10008,
	CONTENT_STREAM_SAVE_BILLING_CONFIG = 10009,
	CONTENT_STREAM_SAVE_ARTICLE = 10010,
	CONTENT_STREAM_LEVEL_SELECT = 10011,
	CONTENT_STREAM_CANCEL_SAVE_LEVEL = 10012,
	CONTENT_STREAM_VIEW_SUBSCRIPTIONS = 10013,
	CONTENT_STREAM_MARK_ARTICLE_CURATED = 10014,
	CONTENT_STREAM_ARTICLE_CURATION_REQUEST = 10015,
	CONTENT_STREAM_SELECT_STREAM = 10016,
	CONTENT_STREAM_DELETE_STREAM = 10017,
	CONTENT_STREAM_CURATE_ARTICLE = 10018,
	CONTENT_STREAM_DELETE_LEVEL = 10019,
	CONTENT_STREAM_ISSUES = 10020,
	CONTENT_STREAM_LEVELS = 10021,
	CONTENT_STREAM_BILLING_CONFIG = 10022,
	CONTENT_STREAM_TODO = 10023,
	CONTENT_STREAM_EDIT = 10024,
	CONTENT_STREAM_REQUEST_CANCEL_SUBSCRIPTION = 10025,
	CONTENT_STREAM_CANCEL_SUBSCRIPTION = 10026,
	CONTENT_STREAM_CALCULATE_PAYMENTS = 10027,
	CONTENT_STREAM_SEND_CURATOR_PAYMENTS = 10028,
	CONTENT_STREAM_SEND_OWNER_PAYMENTS = 10029,
	CONTENT_STREAM_CREATE_BATCH = 20030,
	CONTENT_STREAM_SHOW_BATCH = 20031,
	CONTENT_STREAM_SETUP = 20031,
	CONTENT_STREAM_ACTIVE = 20032,
	CONTENT_STREAM_LEVEL_ADD = 20033,
	CONTENT_STREAM_ADVANCED = 20034,
	CONTENT_STREAM_MOVE_STREAM = 20035,
	CONTENT_STREAM_TAILORING_SELECT = 20036,
	CONTENT_STREAM_ARTICLE_LICENCE = 20037,


	ADD_ARTICLE_LICENCE = 20500,
	EDIT_ARTICLE_LICENCE = 20501,
	SAVE_ARTICLE_LICENCE = 20502,
	SELECT_ARTICLE_LICENCE = 20503,
	MAKE_LICENCE_DEFAULT = 20504,
	ASSIGN_ARTICLE_LICENCE = 20505,
	CHANGE_ARTICLE_LICENCE = 20506,
	VIEW_ARTICLE_LICENCE = 20507,

	SHOW_HELP = 80000,
	LEFT_MOUSE_CLICK = 80001,
	RIGHT_MOUSE_CLICK = 80002,
	PAGE_CHANGE = 80003,
	MENU_RELOAD = 80004,
	DO_SEARCH = 80005,
	SEARCH_FACET_UPDATE = 80006,
	CLOSE_DIALOG = 80007,
	ARTICLE_SELECT_TYPE = 80008,
	CHANGE_SEARCH_RETURN_COUNT = 80009,
	PROPERTY_CHANGED = 80010,
	PUBLISH_VIEWER_ARTICLES = 80011,
	WRITTEN_CATEGORY_MANAGER = 80012,
	ADD_WRITTEN_ARTICLE = 80013,
	ARTICLE_FOLDER_SAVE = 80014,
	ARTICLE_FOLDER_SELECT = 80015,
	ARTICLE_FOLDER_CLEAR = 80016,
	MY_MENU_RELOAD = 80017,
	SHOW_ISSUE_ADD = 80018,
	PDF_UPLOAD = 80019,
	SHOW_SNACKBAR = 80020,
	LOGIN_GOOGLE = 80021,
	GOOGLESHEET_READ_HEADER = 80022,
	GOOGLESHEET_MAPPING = 80023,
	GOOGLESHEET_MAPPING_SET = 80024,
	KEYDOWN = 80025,
	KEYUP = 80026,
	KEYRIGHT = 80027,
	KEYLEFT = 80028,
	PUSH_WORDPRESS = 80029,
	PUSH_SELECTED_WORDPRESS = 80030,
	PUSH_SELECTED_TO_WORDPRESS = 80031,


	VIEW_WP_PLUGIN = 80100,
	ADD_WP_PLUGIN = 80101,
	SAVE_WP_PLUGIN = 80102,
	DELETE_WP_PLUGIN = 80103,
	VIEW_WP_SITE = 80104,


	WEBSITE_SAVE = 20000,
	WEBSITE_CANCEL_SAVE = 20001,
	WEBSITE_SELECT = 20002,
	WEBSITE_DELETE = 20003,
	WEBSITE_VIEWER_CONFIG_SAVE = 20004,
	WEBSITE_VIEWER_CONFIG_SWAP = 20005,
	WEBSITE_VIEWER_CONFIG_HELP = 20006,
	WEBSITE_SEARCH_CONFIG = 20007,
	WEBSITE_AUTH_CONFIG = 20008,
	WEBSITE_TOC_CONFIG = 20009,
	WEBSITE_VIEWER_CONFIG_COPY_LIVE = 20010,
	WEBSITE_USER_SELECT = 20011,
	WEBSITE_SUBSCRIBER_EXPIRY_UPDATE = 20012,
	WEBSITE_TEMPLATE_CONFIG = 20013,
	WEBSITE_VIEWER_CONFIG_FORMAT_JSON = 20014,
	WEBSITE_CLASSIC_CONFIG = 20015,
	WEBSITE_SAVE_CONFIG = 20016,
	WEBSITE_AUTH0_CREATE = 20017,
	WEBSITE_AUTH0_WIZARD = 20018,
	WEBSITE_AUTH_VIEWER_CONFIG = 20019,
	WEBSITE_SAVE_AUTH_VIEWER_CONFIG = 20020,
	WEBSITE_SECURITY = 20021,
	WEBSITE_VIEWER_CONFIG_PUBLISH_JSON = 20022,
	WEBSITE_SUBSCRIBER_SELECT = 20023,
	WEBSITE_LOGIN = 20024,
	WEBSITE_SUBSCRIBER_SAVE = 20025,
	WEBSITE_SUBSCRIBER_ADD = 20026,
	WEBSITE_SUBSCRIBER_IMPORT = 20027,
	WEBSITE_SUBSCRIBER_DO_IMPORT = 20028,

	PUBLICATION_ADD = 30000,
	PUBLICATION_SECTION_MANAGER = 30001,
	PUBLICATION_SECTION_SAVE = 30002,
	PUBLICATION_SECTION_CLEAR = 30003,
	PUBLICATION_SECTION_SELECT = 30004,
	PUBLICATION_PUBLISH_ISSUES = 30005,
	PUBLICATION_UNPUBLISH_ISSUES = 30006,
	CONFIRM_PUBLICATION_PUBLISH_ISSUES = 30007,
	CONFIRM_PUBLICATION_UNPUBLISH_ISSUES = 30008,
	PUBLICATION_IMPORT_METADATA = 30009,
	PUBLICATION_LOG = 30010,
	PUBLICATION_REPUBLISH_ISSUES = 30011,
	CONFIRM_PUBLICATION_REPUBLISH_ISSUES = 30012,
	PUBLICATION_ADD_SCHEDULED_TASK = 30013,
	PUBLICATION_SCHEDULED_TASKS = 30014,
	PUBLICATION_SAVE_SCHEDULED_TASK = 30015,
	PUBLICATION_SCHEDULED_TASK_HISTORY = 30016,
	PUBLICATION_SCHEDULED_TASK_DELETE = 30017,

	ISSUE_SAVE = 40000,
	ISSUE_DELETE = 40001,
	ISSUE_SELECT = 40002,
	ISSUE_CANCEL_SAVE = 40003,
	ISSUE_SAVE_TOC = 40004,
	ISSUE_CLEAR_TOC = 40005,
	ISSUE_EXTRACT = 40006,
	ISSUE_TOC = 40007,
	ISSUE_ADD = 40008,
	ISSUE_FOLIO = 40009,
	ISSUE_CONVERSION_SETTINGS = 40010,
	ISSUE_MANAGE_ARTICLES = 40011,
	ISSUE_DEPLOY = 40012,
	ISSUE_METADATA = 40013,
	ISSUE_REPLACE_PDF = 40014,
	ISSUE_RESTART_CONVERSION = 40015,
	ISSUE_PUBLISH = 40016,
	ISSUE_SAVE_FOLIO = 40017,
	ISSUE_CLEAR_FOLIO = 40018,
	ISSUE_DELETE_CONFIRM = 40019,
	ISSUE_SAVE_VIEWERCONFIG = 40020,
	ISSUE_VIEWERCONFIG = 40021,
	ISSUE_NEWTAB_SELECT = 40022,
	METADATA_SAVE = 40023,
	ISSUE_STATUS = 40024,

	ISSUE_WORDSMART_SAVE_LINK = 40100,
	ISSUE_WORDSMART_CLEAR = 40101,
	ISSUE_WORDSMART_DELETE_LINK = 40102,
	ISSUE_WORDSMART = 40103,
	ISSUE_WORDSMART_PAGE = 40104,
	ISSUE_DATE_SAVE = 40105,
	ISSUE_WORDSMART_PUBLISH = 40106,
	ISSUE_WORDSMART_PAGES = 20107,
	ISSUE_WORDSMART_LINK_OK = 20108,

	ACCOUNT_RESET_PASSWORD = 50000,
	ACCOUNT_RESEND_WELCOME = 50001,
	ACCOUNT_REGISTER = 50002,
	ACCOUNT_LOGIN = 50003,
	ACCOUNT_FORGOTTEN_PASSWORD = 50004,

	ADMIN_SELECT_ACCOUNT = 60000,

	ARTICLE_SELECT = 70000,
	ARTICLE_PREVIEW = 70001,
	ARTICLE_SHOW_SEARCH = 70002,
	ARTICLE_EDIT = 70003,
	ARTICLE_DELETE = 70004,
	ARTICLE_SAVE = 70005,
	ARTICLE_SOURCE_SAVE = 70006,
	ARTICLE_DELETE_REQUEST = 70007,
	ARTICLE_MOVE_PROOF = 70008,
	ARTICLE_APPROVE = 70009,

	EXTRACT_SELECT_TITLE = 90000,
	EXTRACT_SELECT_BODY = 90001,
	EXTRACT_SELECT_IMAGES = 90002,
	EXTRACT_SELECT_CAPTION = 90003,
	EXTRACT_SELECT_CONTRIBUTOR = 90004,

	DRAG_MOVE = 95000,
	DRAG_MOVE_REQUEST = 95001
}
